import { useState, useEffect } from 'react';
import { breakpoints } from '../styles/theme';

/**
 * 通用媒体查询 hook —— 随窗口缩放/设备旋转实时更新。
 * 用于需要按设备"分支渲染"（而非纯 CSS 切换）的场景，例如家长端底部标签栏、
 * 弹窗在手机上切到全屏模式等。
 */
export function useMediaQuery(query) {
  const getMatch = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    // 订阅前先同步一次，避免初始值与当前不一致
    setMatches(mql.matches);
    // 新标准用 addEventListener，旧 Safari(<14) 只有 addListener
    if (mql.addEventListener) {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return matches;
}

/** 手机（≤768px） */
export function useIsMobile() {
  return useMediaQuery(`(max-width: ${breakpoints.phone}px)`);
}

/** 平板及以下（≤1024px，含 iPad） */
export function useIsTablet() {
  return useMediaQuery(`(max-width: ${breakpoints.tablet}px)`);
}
